module.exports = __webpack_public_path__ + "static/media/Carousels-Wedding-Mobile.c6f44c3d.jpg";